export const CustomDimensions = {
	// Visites / Sessions
	PTID: "PTID",
	registrationDate: "registrationDate",
	userCountry: "userCountry",
	envStatus: "envStatus",
	userEnv: "userEnv",
	platformLanguage: "platformLanguage",
	deviceLanguage: "deviceLanguage",
	isTester: "isTester",
	isReviewer: "isReviewer",

	// Actions / Hits
	loginStatus: "loginStatus",
} as const;
